import { render, staticRenderFns } from "./FlashPay.vue?vue&type=template&id=86464ed4&"
import script from "./FlashPay.vue?vue&type=script&lang=ts&"
export * from "./FlashPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports